module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To Confirm",
      "name": "toConfirm"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "Select Batch Number (Type 2+ chars to search)",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchPendingBatchNumbers,
      "loading": _vm.availableBatchesLoading
    },
    on: {
      "change": _vm.handlePendingBatchNumberChange,
      "visible-change": _vm.handlePendingBatchDropdownVisible,
      "clear": _vm.handlePendingBatchNumberClear
    },
    model: {
      value: (_vm.filters.batchFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "batchFilter", $$v)
      },
      expression: "filters.batchFilter"
    }
  }, _vm._l((_vm.availableBatches), function(batch) {
    return _c('el-option', {
      key: batch.batchNumber,
      attrs: {
        "label": batch.batchNumber,
        "value": batch.batchNumber
      }
    }, [_c('span', {
      staticClass: "batch-number"
    }, [_vm._v(_vm._s(batch.batchNumber))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking #",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getPendingPackages.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.trackingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "trackingFilter", $$v)
      },
      expression: "filters.trackingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPendingPackages
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBatchImport
    }
  }, [_vm._v("Batch Import")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showBulkConfirm
    }
  }, [_vm._v("Bulk Confirm")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.showBatchCancel
    }
  }, [_vm._v("Batch Remove")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportPendingBatches
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pendingBatchLoading),
      expression: "pendingBatchLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.pendingPackageList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handlePackageSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "Batch Number",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('strong', [_vm._v(_vm._s(scope.row.tracking))])]), _vm._v(" "), (scope.row.note) ? _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemCount",
      "label": "UPC Items",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseName",
      "label": "Warehouse",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "importDate",
      "label": "Import Time",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "240",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.viewPendingPackageDetail(scope.row)
            }
          }
        }, [_vm._v("Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.confirmSinglePackage(scope.row)
            }
          }
        }, [_vm._v("Confirm")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelSinglePackage(scope.row)
            }
          }
        }, [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPendingBatchPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.dynamicPendingPageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pendingBatchTotal
    },
    on: {
      "size-change": _vm.handlePendingBatchSizeChange,
      "current-change": _vm.changePendingBatchPage
    }
  }), _vm._v(" "), (_vm.filters.batchFilter) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" Filtered by batch, showing 50 items per page\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Mixed Packages",
      "name": "packages"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.packageFilters
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "Select Batch Number (Type 2+ chars to search)",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchBatchNumbers,
      "loading": _vm.mixedPackageBatchesLoading
    },
    on: {
      "change": _vm.handleBatchNumberChange,
      "visible-change": _vm.handleBatchDropdownVisible,
      "clear": _vm.handleBatchNumberClear
    },
    model: {
      value: (_vm.packageFilters.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "batchNumber", $$v)
      },
      expression: "packageFilters.batchNumber"
    }
  }, _vm._l((_vm.mixedPackageBatches), function(batch) {
    return _c('el-option', {
      key: batch.batchNumber,
      attrs: {
        "label": batch.batchNumber,
        "value": batch.batchNumber
      }
    }, [_c('span', {
      staticClass: "batch-number"
    }, [_vm._v(_vm._s(batch.batchNumber))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getMixedPackageList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.packageFilters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "tracking", $$v)
      },
      expression: "packageFilters.tracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getMixedPackageList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Full UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getMixedPackageList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.packageFilters.upc),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "upc", $$v)
      },
      expression: "packageFilters.upc"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getMixedPackageList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Warehouse",
      "clearable": ""
    },
    model: {
      value: (_vm.packageFilters.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "warehouseNo", $$v)
      },
      expression: "packageFilters.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse) {
    return _c('el-option', {
      key: warehouse.warehouseNo,
      attrs: {
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address,
        "value": warehouse.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    model: {
      value: (_vm.packageFilters.packageStatus),
      callback: function($$v) {
        _vm.$set(_vm.packageFilters, "packageStatus", $$v)
      },
      expression: "packageFilters.packageStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Partial Claimed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "All Claimed",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Completed",
      "value": "3"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showCreatePackage
    }
  }, [_vm._v("Create Mixed Package")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "disabled": _vm.selectedPackages.length === 0
    },
    on: {
      "click": _vm.showBulkReverse
    }
  }, [_vm._v("\n              Bulk Reverse (" + _vm._s(_vm.selectedPackages.length) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportMixedPackages
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.packageLoading),
      expression: "packageLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.packageList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handlePackageSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('strong', [_vm._v(_vm._s(scope.row.tracking))])]), _vm._v(" "), (scope.row.batchNumber) ? _c('p', {
          staticClass: "batch-number-display"
        }, [_c('el-tag', {
          attrs: {
            "type": "info",
            "size": "mini"
          }
        }, [_vm._v("Batch: " + _vm._s(scope.row.batchNumber))])], 1) : _vm._e(), _vm._v(" "), (scope.row.note) ? _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Items Status",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Total: " + _vm._s(scope.row.totalItems) + " items")]), _vm._v(" "), _c('p', [_vm._v("Claimed: " + _vm._s(scope.row.claimedItems) + " items")]), _vm._v(" "), _c('p', [_vm._v("Remaining: " + _vm._s(scope.row.unclaimedItems) + " items")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Package Status",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getStatusTagType(scope.row.packageStatus),
            "size": "small"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.getStatusText(scope.row.packageStatus)) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.formatDate(scope.row.createDate)))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("by " + _vm._s(scope.row.createUserName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "min-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewPackageDetail(scope.row)
            }
          }
        }, [_vm._v("View Details")]), _vm._v(" "), (scope.row.packageStatus >= 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimsForPackage(scope.row)
            }
          }
        }, [_vm._v("\n              View Claims\n            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.confirmReversePackage(scope.row)
            }
          }
        }, [_vm._v("\n              Reverse\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.packageCurrentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.packageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.packageTotal
    },
    on: {
      "size-change": _vm.handlePackageSizeChange,
      "current-change": _vm.handlePackageCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "claims"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        Claims Review\n        "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.pendingClaimsCount,
      "hidden": _vm.pendingClaimsCount === 0
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.claimFilters
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "Select Batch Number (Type 2+ chars to search)",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchClaimsBatchNumbers,
      "loading": _vm.claimsBatchesLoading
    },
    on: {
      "change": _vm.handleClaimsBatchNumberChange,
      "visible-change": _vm.handleClaimsBatchDropdownVisible,
      "clear": _vm.handleClaimsBatchNumberClear
    },
    model: {
      value: (_vm.claimFilters.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "batchNumber", $$v)
      },
      expression: "claimFilters.batchNumber"
    }
  }, _vm._l((_vm.claimsBatches), function(batch) {
    return _c('el-option', {
      key: batch.batchNumber,
      attrs: {
        "label": batch.batchNumber,
        "value": batch.batchNumber
      }
    }, [_c('span', {
      staticClass: "batch-number"
    }, [_vm._v(_vm._s(batch.batchNumber))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    model: {
      value: (_vm.claimFilters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "tracking", $$v)
      },
      expression: "claimFilters.tracking"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "UPC",
      "clearable": ""
    },
    model: {
      value: (_vm.claimFilters.upc),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "upc", $$v)
      },
      expression: "claimFilters.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Warehouse",
      "clearable": ""
    },
    model: {
      value: (_vm.claimFilters.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "warehouseNo", $$v)
      },
      expression: "claimFilters.warehouseNo"
    }
  }, _vm._l((_vm.claimWarehouses), function(warehouse) {
    return _c('el-option', {
      key: warehouse.warehouseNo,
      attrs: {
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address,
        "value": warehouse.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Claim Status",
      "clearable": ""
    },
    model: {
      value: (_vm.claimFilters.claimStatus),
      callback: function($$v) {
        _vm.$set(_vm.claimFilters, "claimStatus", $$v)
      },
      expression: "claimFilters.claimStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending Review",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Approved",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Distributed",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Quantity Adjusted",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getClaimList
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.canBatchApprove
    },
    on: {
      "click": _vm.showBatchApprove
    }
  }, [_vm._v("\n              Batch Approve (" + _vm._s(_vm.approvableClaimsCount) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": !_vm.canBatchReject
    },
    on: {
      "click": _vm.showBatchReject
    }
  }, [_vm._v("\n              Batch Reject (" + _vm._s(_vm.rejectableClaimsCount) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canBatchDistribute
    },
    on: {
      "click": _vm.showBatchDistribute
    }
  }, [_vm._v("\n              Batch Distribute (" + _vm._s(_vm.distributableClaimsCount) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "disabled": !_vm.canSetForceChargeTime
    },
    on: {
      "click": _vm.showSetChargeTime
    }
  }, [_vm._v("\n              Set Charge Time (" + _vm._s(_vm.chargeEditableClaimsCount) + ")\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.exportClaimList
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.claimLoading),
      expression: "claimLoading"
    }],
    ref: "claimTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.claimList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handleClaimSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse",
      "min-width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Claimer",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.claimerName))]), _vm._v(" "), _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": scope.row.claimerType === 1 ? 'success' : 'info'
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.claimerTypeDesc) + "\n            ")]), _vm._v(" "), (scope.row.claimerType === 2 && scope.row.targetDoctorName) ? _c('p', {
          staticStyle: {
            "margin-top": "4px",
            "font-size": "12px",
            "color": "#606266"
          }
        }, [_c('i', {
          staticClass: "el-icon-user"
        }), _vm._v(" Doctor: " + _vm._s(scope.row.targetDoctorName) + "\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity Info",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Claimed:\n              "), _c('el-tag', {
          attrs: {
            "type": _vm.getQuantityTagType(scope.row),
            "size": "mini"
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.claimedQty) + "\n              ")])], 1), _vm._v(" "), _c('p', [_vm._v("Available:\n              "), (scope.row.unclaimedQty < 0) ? _c('el-tag', {
          staticClass: "negative-quantity-alert",
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning"
        }), _vm._v(" " + _vm._s(scope.row.unclaimedQty) + "\n              ")]) : _c('span', [_vm._v(_vm._s(scope.row.unclaimedQty))])], 1), _vm._v(" "), _c('p', [_vm._v("Total: " + _vm._s(scope.row.totalQty))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimDate",
      "label": "Claim Date",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.formatDate(scope.row.claimDate)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getClaimStatusTagType(scope.row.claimStatus),
            "size": "small"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.getClaimStatusText(scope.row.claimStatus)) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Charge Time",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "charge-time-display"
        }, [(scope.row.forceChargeTime) ? _c('div', {
          staticClass: "charge-time-forced"
        }, [_c('i', {
          staticClass: "el-icon-time"
        }), _vm._v("\n                Force: " + _vm._s(_vm.formatDate(scope.row.forceChargeTime)) + "\n              ")]) : _c('div', {
          staticClass: "charge-time-normal"
        }, [_c('i', {
          staticClass: "el-icon-clock"
        }), _vm._v("\n                Normal Period\n              ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.claimStatus === 0) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.approveClaim(scope.row)
            }
          }
        }, [_vm._v("Approve")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.showAdjustQuantity(scope.row)
            }
          }
        }, [_vm._v("Adjust")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showRejectClaim(scope.row)
            }
          }
        }, [_vm._v("Reject")])], 1) : (scope.row.claimStatus === 1) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showSingleDistribute(scope.row)
            }
          }
        }, [_vm._v("Distribute")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "title": "Reject this claim if you find errors before distribution"
          },
          on: {
            "click": function($event) {
              return _vm.showRejectClaim(scope.row)
            }
          }
        }, [_vm._v("Reject")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("View Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "title": "Rollback this claim to pending status for re-processing"
          },
          on: {
            "click": function($event) {
              return _vm.rollbackClaimToPending(scope.row)
            }
          }
        }, [_vm._v("Rollback")])], 1) : (scope.row.claimStatus === 2) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("View Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "title": "Rollback this claim to pending status for re-processing"
          },
          on: {
            "click": function($event) {
              return _vm.rollbackClaimToPending(scope.row)
            }
          }
        }, [_vm._v("Rollback")])], 1) : (scope.row.claimStatus === 4) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showSingleDistribute(scope.row)
            }
          }
        }, [_vm._v("Distribute")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "title": "Reject this claim if you find errors before distribution"
          },
          on: {
            "click": function($event) {
              return _vm.showRejectClaim(scope.row)
            }
          }
        }, [_vm._v("Reject")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("View Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "title": "Rollback this claim to pending status for re-processing"
          },
          on: {
            "click": function($event) {
              return _vm.rollbackClaimToPending(scope.row)
            }
          }
        }, [_vm._v("Rollback")])], 1) : _c('div', [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.viewClaimDetail(scope.row)
            }
          }
        }, [_vm._v("View Detail")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.claimCurrentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.claimSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.claimTotal
    },
    on: {
      "size-change": _vm.handleClaimSizeChange,
      "current-change": _vm.handleClaimCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Unclaimed Items",
      "name": "unclaimed"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.unclaimedFilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUnclaimedItemsList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.unclaimedFilters.upc),
      callback: function($$v) {
        _vm.$set(_vm.unclaimedFilters, "upc", $$v)
      },
      expression: "unclaimedFilters.upc"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getUnclaimedItemsList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportUnclaimed
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.unclaimedLoading),
      expression: "unclaimedLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.unclaimedList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unclaimedQty",
      "label": "Unclaimed Qty",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.unclaimedQty))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalPackages",
      "label": "Packages Count",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingList",
      "label": "Related Trackings",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "tracking-list-container"
        }, [(_vm.getTrackingArray(scope.row.trackingList).length <= 2) ? _c('div', {
          staticClass: "tracking-simple"
        }, _vm._l((_vm.getTrackingArray(scope.row.trackingList)), function(tracking, index) {
          return _c('el-tooltip', {
            key: index,
            attrs: {
              "effect": "dark",
              "content": tracking,
              "placement": "top"
            }
          }, [_c('el-tag', {
            staticClass: "tracking-tag",
            attrs: {
              "size": "mini",
              "type": "info"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.getDisplayTracking(tracking)) + "\n                  ")])], 1)
        }), 1) : _c('div', {
          staticClass: "tracking-with-more"
        }, [_vm._l((_vm.getTrackingArray(scope.row.trackingList).slice(0, 2)), function(tracking, index) {
          return _c('el-tooltip', {
            key: index,
            attrs: {
              "effect": "dark",
              "content": tracking,
              "placement": "top"
            }
          }, [_c('el-tag', {
            staticClass: "tracking-tag",
            attrs: {
              "size": "mini",
              "type": "info"
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.getDisplayTracking(tracking)) + "\n                  ")])], 1)
        }), _vm._v(" "), _c('el-popover', {
          attrs: {
            "placement": "top",
            "width": "400",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticClass: "tracking-popover"
        }, [_c('p', {
          staticClass: "popover-title"
        }, [_vm._v("All Related Tracking Numbers (" + _vm._s(_vm.getTrackingArray(scope.row.trackingList).length) + ")")]), _vm._v(" "), _c('div', {
          staticClass: "tracking-grid"
        }, _vm._l((_vm.getTrackingArray(scope.row.trackingList)), function(tracking, index) {
          return _c('el-tag', {
            key: index,
            staticClass: "tracking-tag-full",
            attrs: {
              "size": "small",
              "type": "info"
            }
          }, [_vm._v("\n                        " + _vm._s(tracking) + "\n                      ")])
        }), 1)]), _vm._v(" "), _c('el-tag', {
          staticClass: "tracking-more-tag",
          attrs: {
            "slot": "reference",
            "size": "mini",
            "type": "warning"
          },
          slot: "reference"
        }, [_vm._v("\n                    +" + _vm._s(_vm.getTrackingArray(scope.row.trackingList).length - 2) + " more\n                  ")])], 1)], 2)])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.unclaimedCurrentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.unclaimedSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.unclaimedTotal
    },
    on: {
      "size-change": _vm.handleUnclaimedSizeChange,
      "current-change": _vm.handleUnclaimedCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Import Mixed Packages",
      "width": "80%",
      "visible": _vm.batchImportDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchImportDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "importForm",
    attrs: {
      "model": _vm.importForm,
      "rules": _vm.importRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Batch Number",
      "prop": "batchNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "placeholder": "Loading..."
    },
    model: {
      value: (_vm.importForm.batchNumber),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "batchNumber", $$v)
      },
      expression: "importForm.batchNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select warehouse"
    },
    model: {
      value: (_vm.importForm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "warehouseNo", $$v)
      },
      expression: "importForm.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse) {
    return _c('el-option', {
      key: warehouse.warehouseNo,
      attrs: {
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address,
        "value": warehouse.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Import Method"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.importForm.importMethod),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "importMethod", $$v)
      },
      expression: "importForm.importMethod"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "text"
    }
  }, [_vm._v("Text Format")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "excel"
    }
  }, [_vm._v("Excel File")])], 1)], 1), _vm._v(" "), (_vm.importForm.importMethod === 'text') ? _c('el-form-item', {
    attrs: {
      "label": "Package Data",
      "prop": "textContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "Format: Tracking,UPC,Quantity or Tracking[Tab]UPC[Tab]Quantity (one per line)&#10;Example: 1Z999AA1234567890,123456789012,2"
    },
    model: {
      value: (_vm.importForm.textContent),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "textContent", $$v)
      },
      expression: "importForm.textContent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "import-hint"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('span', [_vm._v("Supports multi-line, tab-separated fields, comma-separated, and space-separated formats")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "right",
      "effect": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "tooltip-format-guide"
  }, [_c('div', [_c('strong', [_vm._v("📋 Supported Formats:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("🔹 Multi-line comma-separated (Recommended):")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  1Z999AA1234567890,123456789012,2"), _c('br'), _vm._v("\n                  1Z888BB9876543210,987654321098,1"), _c('br'), _vm._v("\n                  1Z777CC5555555555,456789123456,3\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("🔹 Tab-separated fields (one per line):")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  1Z999AA1234567890[Tab]123456789012[Tab]2"), _c('br'), _vm._v("\n                  1Z888BB9876543210[Tab]987654321098[Tab]1"), _c('br'), _vm._v("\n                  Format: Tracking[Tab]UPC[Tab]Quantity\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("🔹 Space-separated packages (single line):")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  1Z999-AA1234567890,123456789012,2 1Z888-BB9876543210,987654321098,1\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("🔹 With spaces around commas:")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  1Z999-AA1234567890 , 123456789012 , 2"), _c('br'), _vm._v("\n                  1Z888-BB9876543210 , 987654321098 , 1\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#E6A23C"
    }
  }, [_c('strong', [_vm._v("⚠️ Important:")]), _vm._v(" Each package needs exactly 3 fields (Tracking, UPC, Quantity)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#67C23A",
      "margin-top": "8px"
    }
  }, [_c('strong', [_vm._v("✓ Note:")]), _vm._v(" Extra spaces will be automatically cleaned up")])])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question hover-help-icon"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.importForm.importMethod === 'excel') ? _c('el-form-item', {
    attrs: {
      "label": "Excel File",
      "prop": "excelFile"
    }
  }, [_c('el-upload', {
    ref: "excelUpload",
    attrs: {
      "action": _vm.excelUploadUrl,
      "headers": _vm.uploadHeaders,
      "data": _vm.excelUploadData,
      "on-success": _vm.handleExcelUploadSuccess,
      "on-error": _vm.handleExcelUploadError,
      "file-list": _vm.excelFileList,
      "limit": 1,
      "name": "file",
      "accept": ".xlsx,.xls",
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Only .xlsx/.xls files are supported")])]), _vm._v(" "), _c('div', {
    staticClass: "import-hint"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('span', [_vm._v("Excel format: Column A=Tracking, Column B=UPC, Column C=Quantity")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "right",
      "effect": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "tooltip-format-guide"
  }, [_c('div', [_c('strong', [_vm._v("📊 Excel File Requirements:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Required columns (in exact order):")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_c('strong', [_vm._v("Column A:")]), _vm._v(" Tracking Number"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Column B:")]), _vm._v(" UPC Code"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Column C:")]), _vm._v(" Quantity\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Example:")])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-example"
  }, [_vm._v("\n                  A1: 1Z999AA1234567890    B1: 123456789012    C1: 2"), _c('br'), _vm._v("\n                  A2: 1Z888BB9876543210    B2: 987654321098    C2: 1\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#E6A23C"
    }
  }, [_c('strong', [_vm._v("⚠️ Important:")]), _vm._v(" No headers, start with data from row 1")])])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question hover-help-icon"
  })])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeBatchImportDialog
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.importing
    },
    on: {
      "click": _vm.validateImportData
    }
  }, [_vm._v("\n        Import\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "package-detail-dialog",
    attrs: {
      "title": "Package Detail & Management",
      "width": "95%",
      "visible": _vm.batchDetailDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDetailDialogVisible = $event
      }
    }
  }, [(_vm.currentPackageDetail) ? _c('div', [_c('el-card', {
    staticClass: "batch-summary-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "header-title"
  }, [_c('i', {
    staticClass: "el-icon-box"
  }), _vm._v("\n            Package Information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "3px 8px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.refreshPendingPackageDetail
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" Refresh\n            ")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Batch Number:")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "info",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.batchNumber))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Tracking Number:")]), _vm._v(" "), _c('code', {
    staticClass: "tracking-code"
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.tracking))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Total UPC Items:")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.itemCount))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("UPC Types:")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v(_vm._s((_vm.currentPackageDetail.items || []).length))])], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": _vm.getBatchStatusType(_vm.currentPackageDetail.status)
    }
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.status))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Warehouse:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.warehouseName))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Import Date:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.currentPackageDetail.importDate))])])])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "items-card",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "header-title"
  }, [_c('i', {
    staticClass: "el-icon-goods"
  }), _vm._v("\n            UPC Items Management (" + _vm._s((_vm.currentPackageDetail.items || []).length) + " items)\n          ")]), _vm._v(" "), (_vm.currentPackageDetail.status === 'pending') ? _c('div', {
    staticClass: "header-actions"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-delete",
      "disabled": _vm.selectedUPCs.length === 0
    },
    on: {
      "click": _vm.bulkDeleteUPCs
    }
  }, [_vm._v("\n              Delete Selected (" + _vm._s(_vm.selectedUPCs.length) + ")\n            ")])], 1) : _vm._e()]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.batchDetailLoading),
      expression: "batchDetailLoading"
    }],
    ref: "upcTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.currentPackageDetail.items || [],
      "row-key": "upc"
    },
    on: {
      "selection-change": _vm.handleUPCSelectionChange
    }
  }, [(_vm.currentPackageDetail.status === 'pending') ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC Code",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 3454015104)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name",
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.productName) ? _c('span', {
          staticClass: "product-name"
        }, [_vm._v(_vm._s(scope.row.productName))]) : _c('span', {
          staticClass: "no-data"
        }, [_vm._v("No product info")])]
      }
    }], null, false, 1232526568)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Quantity",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "medium"
          }
        }, [_vm._v(_vm._s(scope.row.quantity))])]
      }
    }], null, false, 77797758)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.status === 'pending' ? 'warning' : 'success',
            "size": "small"
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.status) + "\n              ")])]
      }
    }], null, false, 2733133994)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "importDate",
      "label": "Import Time",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "import-time"
        }, [_vm._v(_vm._s(scope.row.importDate))])]
      }
    }], null, false, 887448748)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Validation",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.errorMessage) ? _c('div', {
          staticClass: "validation-error"
        }, [_c('el-tooltip', {
          attrs: {
            "content": scope.row.errorMessage,
            "placement": "top"
          }
        }, [_c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "small"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning"
        }), _vm._v(" Error\n                  ")])], 1)], 1) : _c('div', {
          staticClass: "validation-success"
        }, [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        }), _vm._v(" Valid\n                ")])], 1)]
      }
    }], null, false, 1424992424)
  }), _vm._v(" "), (_vm.currentPackageDetail.status === 'pending') ? _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "150",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit",
            "title": "Edit this UPC"
          },
          on: {
            "click": function($event) {
              return _vm.editSingleUPC(scope.row, scope.$index)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete",
            "title": "Remove this UPC from package"
          },
          on: {
            "click": function($event) {
              return _vm.deleteSingleUPC(scope.row, scope.$index)
            }
          }
        })]
      }
    }], null, false, 1521781754)
  }) : _vm._e()], 1)], 1)], 1) : _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "el-icon-box"
  }), _vm._v(" "), _c('p', [_vm._v("No package detail available")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "footer-left"
  }, [(_vm.currentPackageDetail && _vm.currentPackageDetail.items) ? _c('span', {
    staticClass: "item-count-info"
  }, [_vm._v("\n          Total: " + _vm._s(_vm.currentPackageDetail.items.length) + " UPC types,\n          " + _vm._s(_vm.currentPackageDetail.items.reduce(function (sum, item) { return sum + item.quantity; }, 0)) + " items\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchDetailDialogVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.currentPackageDetail && _vm.currentPackageDetail.status === 'pending') ? _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-check"
    },
    on: {
      "click": _vm.confirmBatchFromDetail
    }
  }, [_vm._v("\n          Confirm This Package\n        ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk Confirm Packages",
      "width": "70%",
      "visible": _vm.bulkConfirmDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkConfirmDialogVisible = $event
      }
    }
  }, [(_vm.selectedPackages.length > 0) ? _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": ("You are about to confirm " + (_vm.selectedPackages.length) + " package(s)"),
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.selectedPackages
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "Batch Number",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemCount",
      "label": "UPC Items",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseName",
      "label": "Warehouse",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "importDate",
      "label": "Import Date",
      "min-width": "140"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#909399",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("\n        This operation will confirm and create mixed packages from all selected packages. This action cannot be undone.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.bulkConfirmDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.bulkConfirming
    },
    on: {
      "click": _vm.executeBulkConfirm
    }
  }, [_vm._v("\n        Confirm All Packages\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Package Detail",
      "width": "90%",
      "visible": _vm.packageDetailDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.packageDetailDialogVisible = $event
      }
    }
  }, [(_vm.currentPackageDetail) ? _c('div', [_c('el-card', {
    staticClass: "package-info-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v("Package Information")])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.refreshMixedPackageDetail
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" Refresh\n          ")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.packageInfoRows,
      "border": "",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "label1",
      "width": "120",
      "class-name": "info-label-cell"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('strong', [_vm._v(_vm._s(scope.row.label1))])]
      }
    }], null, false, 257521838)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value1",
      "min-width": "160",
      "class-name": "info-value-cell"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.label1 === 'Status:') ? _c('span', [_c('el-tag', {
          attrs: {
            "type": _vm.getPackageStatusType(_vm.currentPackageDetail.packageStatus)
          }
        }, [_vm._v("\n                  " + _vm._s(scope.row.value1) + "\n                ")])], 1) : _c('span', [_vm._v(_vm._s(scope.row.value1))])]
      }
    }], null, false, 3442002515)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "label2",
      "width": "120",
      "class-name": "info-label-cell"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('strong', [_vm._v(_vm._s(scope.row.label2))])]
      }
    }], null, false, 3252667821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value2",
      "min-width": "160",
      "class-name": "info-value-cell"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "label3",
      "width": "120",
      "class-name": "info-label-cell"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('strong', [_vm._v(_vm._s(scope.row.label3))])]
      }
    }], null, false, 4148063532)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value3",
      "min-width": "160",
      "class-name": "info-value-cell"
    }
  })], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "package-items-card",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v("Package Items")])])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.packageDetailLoading),
      expression: "packageDetailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.currentPackageDetail.details || []
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalQty",
      "label": "Total Qty",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Claimed",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unclaimedQty",
      "label": "Remaining",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: {
            'text-warning': scope.row.unclaimedQty > 0
          }
        }, [_vm._v(_vm._s(scope.row.unclaimedQty))])]
      }
    }], null, false, 3644581712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "detailStatus",
      "label": "Status",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getDetailStatusTagType(scope.row.detailStatus),
            "size": "small"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.getDetailStatusText(scope.row.detailStatus)) + "\n              ")])]
      }
    }], null, false, 3309153939)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showEditUPCQty(scope.row)
            }
          }
        }, [_vm._v("\n                Edit UPC Qty\n              ")])]
      }
    }], null, false, 496122323)
  })], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "package-claims-card",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v("Claim Records")])])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.packageDetailLoading),
      expression: "packageDetailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.currentPackageDetail.claims || []
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Claimer",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.claimerName))]), _vm._v(" "), _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": scope.row.claimerType === 1 ? 'success' : 'info'
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.claimerTypeDesc) + "\n              ")])]
      }
    }], null, false, 1677758685)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Claimed Qty",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getClaimStatusTagType(scope.row.claimStatus),
            "size": "small"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.getClaimStatusText(scope.row.claimStatus)) + "\n              ")])]
      }
    }], null, false, 2461212755)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimDate",
      "label": "Claim Date",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.formatDate(scope.row.claimDate)) + "\n            ")]
      }
    }], null, false, 3999726357)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Distribute Date",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.distributeDate) ? _c('div', {
          staticClass: "distribute-date"
        }, [_c('i', {
          staticClass: "el-icon-box"
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(scope.row.distributeDate)))])]) : _c('span', {
          staticClass: "note"
        }, [_vm._v("Not distributed")])]
      }
    }], null, false, 851131742)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewReason",
      "label": "Review Note",
      "min-width": "200"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.packageDetailDialogVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.currentPackageDetail && _vm.currentPackageDetail.packageStatus === 'active') ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reversePackageFromDetail
    }
  }, [_vm._v("\n        Reverse Package\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Approve Claims",
      "width": "70%",
      "visible": _vm.batchApproveDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchApproveDialogVisible = $event
      }
    }
  }, [(_vm.selectedClaims.length > 0) ? _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": ("You are about to approve " + (_vm.selectedClaims.length) + " claim(s)"),
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.selectedClaims
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "claimId",
      "label": "Claim ID",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Quantity",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimDate",
      "label": "Claim Date",
      "min-width": "140"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "color": "#909399",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "el-icon-info-filled"
  }), _vm._v("\n        This operation will approve all selected claims. Approved claims can then be distributed.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchApproveDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchApproving
    },
    on: {
      "click": _vm.executeBatchApprove
    }
  }, [_vm._v("\n        Approve All Claims\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Distribute Claims",
      "width": "70%",
      "visible": _vm.batchDistributeDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDistributeDialogVisible = $event
      }
    }
  }, [(_vm.selectedClaims.length > 0) ? _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": ("You are about to distribute " + (_vm.selectedClaims.length) + " claim(s) to inventory"),
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.selectedClaims
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "claimId",
      "label": "Claim ID",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Quantity",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimStatusDesc",
      "label": "Status",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getClaimStatusType(scope.row.claimStatus),
            "size": "small"
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.claimStatusDesc) + "\n            ")])]
      }
    }], null, false, 3999149988)
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#909399",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("\n        This operation will distribute inventory to claimers and generate FBM records for billing. This action cannot be undone.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchDistributeDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchDistributing
    },
    on: {
      "click": _vm.executeBatchDistribute
    }
  }, [_vm._v("\n        Distribute All Claims\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Adjust Claim Quantity",
      "width": "50%",
      "visible": _vm.adjustClaimDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.adjustClaimDialogVisible = $event
      }
    }
  }, [(_vm.currentClaimForAdjust) ? _c('div', [_c('el-form', {
    ref: "adjustForm",
    attrs: {
      "model": _vm.adjustForm,
      "rules": _vm.adjustRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Claim ID:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.claimId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.tracking))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.upc))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Claimer:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.claimerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Qty:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForAdjust.claimedQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Quantity:",
      "prop": "newQuantity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "min": 1,
      "max": _vm.currentClaimForAdjust.availableQty || 999
    },
    model: {
      value: (_vm.adjustForm.newQuantity),
      callback: function($$v) {
        _vm.$set(_vm.adjustForm, "newQuantity", $$v)
      },
      expression: "adjustForm.newQuantity"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#909399"
    }
  }, [_vm._v("\n            Available: " + _vm._s(_vm.currentClaimForAdjust.availableQty || 0) + "\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reason:",
      "prop": "adjustReason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Please explain the reason for quantity adjustment"
    },
    model: {
      value: (_vm.adjustForm.adjustReason),
      callback: function($$v) {
        _vm.$set(_vm.adjustForm, "adjustReason", $$v)
      },
      expression: "adjustForm.adjustReason"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.adjustClaimDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.adjusting
    },
    on: {
      "click": _vm.executeAdjustClaim
    }
  }, [_vm._v("\n        Adjust Quantity\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Reject Claim",
      "width": "50%",
      "visible": _vm.rejectClaimDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectClaimDialogVisible = $event
      }
    }
  }, [(_vm.currentClaimForReject) ? _c('div', [_c('el-form', {
    ref: "rejectForm",
    attrs: {
      "model": _vm.rejectForm,
      "rules": _vm.rejectRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Claim ID:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.claimId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tracking:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.tracking))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.upc))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Claimer:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.claimerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentClaimForReject.claimedQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reject Reason:",
      "prop": "rejectReason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Please explain why this claim is being rejected"
    },
    model: {
      value: (_vm.rejectForm.rejectReason),
      callback: function($$v) {
        _vm.$set(_vm.rejectForm, "rejectReason", $$v)
      },
      expression: "rejectForm.rejectReason"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.rejectClaimDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.rejecting
    },
    on: {
      "click": _vm.executeRejectClaim
    }
  }, [_vm._v("\n        Reject Claim\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Set Force Charge Time",
      "width": "60%",
      "visible": _vm.forceChargeTimeDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.forceChargeTimeDialogVisible = $event
      }
    }
  }, [(_vm.selectedClaims.length > 0) ? _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": ("Setting force charge time for " + (_vm.selectedClaims.length) + " claim(s)"),
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "forceChargeForm",
    attrs: {
      "model": _vm.forceChargeForm,
      "rules": _vm.forceChargeRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Force Charge Time:",
      "prop": "forceChargeTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select date and time",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.forceChargeForm.forceChargeTime),
      callback: function($$v) {
        _vm.$set(_vm.forceChargeForm, "forceChargeTime", $$v)
      },
      expression: "forceChargeForm.forceChargeTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reason:",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Please explain why force charge time is being set"
    },
    model: {
      value: (_vm.forceChargeForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.forceChargeForm, "reason", $$v)
      },
      expression: "forceChargeForm.reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h4', [_vm._v("Selected Claims:")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.selectedClaims
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "claimId",
      "label": "Claim ID",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimStatusDesc",
      "label": "Status",
      "width": "120",
      "align": "center"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "color": "#909399",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "el-icon-info-filled"
  }), _vm._v("\n        Force charge time will override the normal free storage period. Claims will start incurring storage fees from the specified time.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.forceChargeTimeDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.settingForceCharge
    },
    on: {
      "click": _vm.executeSetForceChargeTime
    }
  }, [_vm._v("\n        Set Force Charge Time\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit UPC Item",
      "visible": _vm.editUPCDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editUPCDialog = $event
      },
      "close": _vm.cancelUPCEdit
    }
  }, [_c('el-form', {
    ref: "editUPCForm",
    attrs: {
      "model": _vm.editUPCForm,
      "rules": _vm.editUPCRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UPC Code",
      "prop": "upc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter UPC code",
      "maxlength": 50,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.editUPCForm.upc),
      callback: function($$v) {
        _vm.$set(_vm.editUPCForm, "upc", $$v)
      },
      expression: "editUPCForm.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1,
      "max": 9999,
      "controls-position": "right"
    },
    model: {
      value: (_vm.editUPCForm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.editUPCForm, "quantity", $$v)
      },
      expression: "editUPCForm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "placeholder": "Original UPC code"
    },
    model: {
      value: (_vm.editUPCForm.originalUpc),
      callback: function($$v) {
        _vm.$set(_vm.editUPCForm, "originalUpc", $$v)
      },
      expression: "editUPCForm.originalUpc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Qty"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": true,
      "controls-position": "right"
    },
    model: {
      value: (_vm.editUPCForm.originalQuantity),
      callback: function($$v) {
        _vm.$set(_vm.editUPCForm, "originalQuantity", $$v)
      },
      expression: "editUPCForm.originalQuantity"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelUPCEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.savingUPCEdit
    },
    on: {
      "click": _vm.saveUPCEdit
    }
  }, [_vm._v("\n        Save Changes\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Create Mixed Package",
      "visible": _vm.createPackageDialog,
      "width": "760px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.createPackageDialog = $event
      },
      "close": _vm.resetCreateForm
    }
  }, [_c('el-form', {
    ref: "createPackageForm",
    attrs: {
      "model": _vm.createPackageForm,
      "rules": _vm.createPackageRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking #",
      "prop": "tracking"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "570px"
    },
    attrs: {
      "placeholder": "Enter tracking number"
    },
    model: {
      value: (_vm.createPackageForm.tracking),
      callback: function($$v) {
        _vm.$set(_vm.createPackageForm, "tracking", $$v)
      },
      expression: "createPackageForm.tracking"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "570px"
    },
    attrs: {
      "placeholder": "Select warehouse"
    },
    model: {
      value: (_vm.createPackageForm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.createPackageForm, "warehouseNo", $$v)
      },
      expression: "createPackageForm.warehouseNo"
    }
  }, _vm._l((_vm.warehouses), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address,
        "value": warehouse.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Items"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "570px"
    },
    attrs: {
      "data": _vm.createPackageForm.items,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "UPC",
      "prop": "upc",
      "width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "Enter UPC"
          },
          model: {
            value: (scope.row.upc),
            callback: function($$v) {
              _vm.$set(scope.row, "upc", $$v)
            },
            expression: "scope.row.upc"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity",
      "prop": "qty",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "min": 1,
            "placeholder": "Qty"
          },
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "140px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removePackageItem(scope.$index)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPackageItem
    }
  }, [_vm._v("Add Item")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelCreatePackage
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.createPackageLoading
    },
    on: {
      "click": _vm.createMixedPackage
    }
  }, [_vm._v("Create")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Adjust Claim Quantity",
      "visible": _vm.adjustQuantityDialog,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.adjustQuantityDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "adjustQuantityForm",
    attrs: {
      "model": _vm.adjustQuantityForm,
      "rules": _vm.adjustQuantityRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Original Qty"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.adjustQuantityForm.originalQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Quantity",
      "prop": "newQuantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.adjustQuantityForm.maxQty,
      "placeholder": "New quantity"
    },
    model: {
      value: (_vm.adjustQuantityForm.newQuantity),
      callback: function($$v) {
        _vm.$set(_vm.adjustQuantityForm, "newQuantity", $$v)
      },
      expression: "adjustQuantityForm.newQuantity"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_vm._v("\n          Max adjustable: " + _vm._s(_vm.adjustQuantityForm.maxQty) + "\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reason (Optional)",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Enter adjustment reason (optional)"
    },
    model: {
      value: (_vm.adjustQuantityForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.adjustQuantityForm, "reason", $$v)
      },
      expression: "adjustQuantityForm.reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.adjustQuantityDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.adjustQuantityLoading
    },
    on: {
      "click": _vm.confirmAdjustQuantity
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Reject Claim",
      "visible": _vm.rejectClaimDialog,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectClaimDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "rejectClaimForm",
    attrs: {
      "model": _vm.rejectClaimForm,
      "rules": _vm.rejectClaimRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Reason",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Please enter rejection reason"
    },
    model: {
      value: (_vm.rejectClaimForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.rejectClaimForm, "reason", $$v)
      },
      expression: "rejectClaimForm.reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.rejectClaimDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.rejectClaimLoading
    },
    on: {
      "click": _vm.confirmRejectClaim
    }
  }, [_vm._v("Reject")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Distribute Inventory",
      "visible": _vm.singleDistributeDialog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.singleDistributeDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Claim Information")]), _vm._v(" "), (_vm.singleDistributeClaim) ? _c('div', {
    staticStyle: {
      "background": "#f5f7fa",
      "padding": "15px",
      "border-radius": "4px",
      "margin-bottom": "20px"
    }
  }, [_c('p', [_c('strong', [_vm._v("Tracking:")]), _vm._v(" " + _vm._s(_vm.singleDistributeClaim.tracking))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("UPC:")]), _vm._v(" " + _vm._s(_vm.singleDistributeClaim.upc))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Quantity:")]), _vm._v(" " + _vm._s(_vm.singleDistributeClaim.claimedQty))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Claimer:")]), _vm._v(" " + _vm._s(_vm.singleDistributeClaim.claimerName) + " (" + _vm._s(_vm.singleDistributeClaim.claimerTypeDesc) + ")")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Current Charge Time:")]), _vm._v(" "), (_vm.singleDistributeClaim.forceChargeTime) ? _c('span', {
    staticClass: "charge-time-forced"
  }, [_vm._v("\n            " + _vm._s(_vm.formatDate(_vm.singleDistributeClaim.forceChargeTime)) + "\n          ")]) : _c('span', {
    staticClass: "charge-time-normal"
  }, [_vm._v("Normal Period")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Charge Strategy Setting")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.singleDistributeForm.chargeTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.singleDistributeForm, "chargeTimeOption", $$v)
      },
      expression: "singleDistributeForm.chargeTimeOption"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal"
    }
  }, [_vm._v("Use normal free period (Product > User > Default 3 months)")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "immediate"
    }
  }, [_vm._v("Start charging immediately")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("Custom charge start time")])], 1)]), _vm._v(" "), (_vm.singleDistributeForm.chargeTimeOption === 'custom') ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select charge start time",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.singleDistributeForm.customChargeTime),
      callback: function($$v) {
        _vm.$set(_vm.singleDistributeForm, "customChargeTime", $$v)
      },
      expression: "singleDistributeForm.customChargeTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.singleDistributeDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.singleDistributeLoading
    },
    on: {
      "click": _vm.confirmSingleDistribute
    }
  }, [_vm._v("\n        Confirm Distribute\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Batch Distribute Inventory",
      "visible": _vm.batchDistributeDialog,
      "width": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDistributeDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Selected Claims (" + _vm._s(_vm.selectedClaims.length) + " items)")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.selectedClaims,
      "size": "small",
      "max-height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Qty",
      "width": "60",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Current Charge Time",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "datetime",
            "placeholder": "Select charge time",
            "format": "yyyy-MM-dd HH:mm:ss",
            "value-format": "yyyy-MM-dd HH:mm:ss",
            "size": "mini",
            "clearable": ""
          },
          model: {
            value: (scope.row.editableChargeTime),
            callback: function($$v) {
              _vm.$set(scope.row, "editableChargeTime", $$v)
            },
            expression: "scope.row.editableChargeTime"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Batch Charge Time Setting")]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "title": "Select a batch setting option and click Apply to quickly fill all Current Charge Time values in the table above. You can then adjust individual values before confirming.",
      "type": "info",
      "closable": false
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start",
      "gap": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "8px"
    },
    model: {
      value: (_vm.batchDistributeForm.chargeTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.batchDistributeForm, "chargeTimeOption", $$v)
      },
      expression: "batchDistributeForm.chargeTimeOption"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal"
    }
  }, [_vm._v("Use normal free period (Product > User > Default 3 months)")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "immediate"
    }
  }, [_vm._v("Start charging immediately")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("Custom charge start time")])], 1), _vm._v(" "), (_vm.batchDistributeForm.chargeTimeOption === 'custom') ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select charge start time",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.batchDistributeForm.customChargeTime),
      callback: function($$v) {
        _vm.$set(_vm.batchDistributeForm, "customChargeTime", $$v)
      },
      expression: "batchDistributeForm.customChargeTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.batchDistributeForm.chargeTimeOption || (_vm.batchDistributeForm.chargeTimeOption === 'custom' && !_vm.batchDistributeForm.customChargeTime)
    },
    on: {
      "click": _vm.applyBatchChargeTime
    }
  }, [_vm._v("\n            Apply to All\n          ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchDistributeDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.batchDistributeLoading
    },
    on: {
      "click": _vm.confirmBatchDistribute
    }
  }, [_vm._v("\n        Confirm Distribute\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Set Force Charge Time",
      "visible": _vm.setChargeTimeDialog,
      "width": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.setChargeTimeDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Editable Claims (" + _vm._s(_vm.editableClaimIds.length) + " items)")]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "title": "Note: Only approved and quantity-adjusted claims can have their charge time modified before distribution.",
      "type": "info",
      "closable": false
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.editableClaims,
      "size": "small",
      "max-height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimedQty",
      "label": "Qty",
      "width": "60",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "claimerName",
      "label": "Claimer",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Current Charge Time",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-date-picker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "datetime",
            "placeholder": "Select charge time",
            "format": "yyyy-MM-dd HH:mm:ss",
            "value-format": "yyyy-MM-dd HH:mm:ss",
            "size": "mini",
            "clearable": ""
          },
          model: {
            value: (scope.row.editableChargeTime),
            callback: function($$v) {
              _vm.$set(scope.row, "editableChargeTime", $$v)
            },
            expression: "scope.row.editableChargeTime"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Batch Charge Time Setting")]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "title": "Select a batch setting option and click Apply to quickly fill all Current Charge Time values in the table above. You can then adjust individual values before confirming.",
      "type": "info",
      "closable": false
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start",
      "gap": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "8px"
    },
    model: {
      value: (_vm.setChargeTimeForm.chargeTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.setChargeTimeForm, "chargeTimeOption", $$v)
      },
      expression: "setChargeTimeForm.chargeTimeOption"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal"
    }
  }, [_vm._v("Restore to normal free period")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "immediate"
    }
  }, [_vm._v("Start charging immediately")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("Set custom charge start time")])], 1), _vm._v(" "), (_vm.setChargeTimeForm.chargeTimeOption === 'custom') ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select charge start time",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.setChargeTimeForm.customChargeTime),
      callback: function($$v) {
        _vm.$set(_vm.setChargeTimeForm, "customChargeTime", $$v)
      },
      expression: "setChargeTimeForm.customChargeTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.setChargeTimeForm.chargeTimeOption || (_vm.setChargeTimeForm.chargeTimeOption === 'custom' && !_vm.setChargeTimeForm.customChargeTime)
    },
    on: {
      "click": _vm.applyBatchChargeTimeSetting
    }
  }, [_vm._v("\n            Apply to All\n          ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.setChargeTimeDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.setChargeTimeLoading
    },
    on: {
      "click": _vm.confirmSetChargeTime
    }
  }, [_vm._v("\n        Confirm Setting\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Claim Detail",
      "visible": _vm.claimDetailDialog,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.claimDetailDialog = $event
      },
      "close": _vm.onClaimDetailClose
    }
  }, [(_vm.claimDetail) ? _c('div', [_c('el-descriptions', {
    staticClass: "claim-detail-descriptions",
    attrs: {
      "title": "Claim Information",
      "column": 3,
      "border": ""
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": "Tracking #",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.tracking))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "UPC",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.upc))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Claimer",
      "label-class-name": "claim-label"
    }
  }, [_c('div', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.claimDetail.claimerName))])]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": _vm.claimDetail.claimerType === 1 ? 'success' : 'info'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.claimDetail.claimerTypeDesc) + "\n            ")])], 1)]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Product Name",
      "span": 3,
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.productName) ? _c('div', {
    staticClass: "product-name-container"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.claimDetail.productName,
      "placement": "top-start"
    }
  }, [_c('span', {
    staticClass: "product-name-text"
  }, [_vm._v(_vm._s(_vm.claimDetail.productName))])])], 1) : _c('span', {
    staticClass: "note"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Claimed Qty",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.claimedQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Total Available",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.totalQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Unclaimed Qty",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.claimDetail.unclaimedQty))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Claim Date",
      "label-class-name": "claim-label"
    }
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.claimDetail.claimDate)))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Status",
      "label-class-name": "claim-label"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.getClaimStatusTagType(_vm.claimDetail.claimStatus)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getClaimStatusText(_vm.claimDetail.claimStatus)) + "\n          ")])], 1), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Charge Time",
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.forceChargeTime) ? _c('div', {
    staticClass: "charge-time-forced"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v("\n            Force: " + _vm._s(_vm.formatDate(_vm.claimDetail.forceChargeTime)) + "\n          ")]) : _c('div', {
    staticClass: "charge-time-normal"
  }, [_c('i', {
    staticClass: "el-icon-clock"
  }), _vm._v("\n            Normal Period\n          ")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Review Date",
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.reviewDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.claimDetail.reviewDate)))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("Not reviewed yet")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Reviewed By",
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.reviewByName) ? _c('span', [_vm._v(_vm._s(_vm.claimDetail.reviewByName))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Distribute Date",
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.distributeDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.claimDetail.distributeDate)))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("Not distributed yet")])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "Review Note",
      "span": 3,
      "label-class-name": "claim-label"
    }
  }, [(_vm.claimDetail.reviewReason) ? _c('p', [_vm._v(_vm._s(_vm.claimDetail.reviewReason))]) : _c('span', {
    staticClass: "note"
  }, [_vm._v("No review note")])])], 1)], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "40px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#909399",
      "font-size": "14px"
    }
  }, [_vm._v("No claim detail data available")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk Reverse by Batch",
      "width": "80%",
      "visible": _vm.batchBulkReverseDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchBulkReverseDialogVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "label": "Batch Number:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Select a batch number",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeBatchNumberForBulkReverse
    },
    model: {
      value: (_vm.selectedBatchNumber),
      callback: function($$v) {
        _vm.selectedBatchNumber = $$v
      },
      expression: "selectedBatchNumber"
    }
  }, _vm._l((_vm.availableBatchNumbers), function(batch, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": batch,
        "label": batch
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.batchPackagesLoading),
      expression: "batchPackagesLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.batchPackagesList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking #",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Items Status",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Total: " + _vm._s(scope.row.totalItems) + " items")]), _vm._v(" "), _c('p', [_vm._v("Claimed: " + _vm._s(scope.row.claimedItems) + " items")]), _vm._v(" "), _c('p', [_vm._v("Remaining: " + _vm._s(scope.row.unclaimedItems) + " items")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Package Status",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.getStatusTagType(scope.row.packageStatus),
            "size": "small"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.getStatusText(scope.row.packageStatus)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Create Date",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.formatDate(scope.row.createDate)))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("by " + _vm._s(scope.row.createUserName))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchBulkReverseDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.batchBulkReverseLoading,
      "disabled": !_vm.selectedBatchNumber || _vm.batchPackagesList.length === 0
    },
    on: {
      "click": _vm.executeBatchBulkReverse
    }
  }, [_vm._v("\n        Bulk Reverse (" + _vm._s(_vm.batchPackagesList.length) + " packages)\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit UPC Quantity in Mixed Package",
      "visible": _vm.editMixedPackageUPCQtyDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editMixedPackageUPCQtyDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "editMixedPackageUPCQtyForm",
    attrs: {
      "model": _vm.editMixedPackageUPCQtyForm,
      "rules": _vm.editMixedPackageUPCQtyRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editMixedPackageUPCQtyForm.upc))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editMixedPackageUPCQtyForm.productName || 'N/A'))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Current Total Qty"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editMixedPackageUPCQtyForm.currentTotalQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Claimed Qty"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editMixedPackageUPCQtyForm.claimedQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Total Qty",
      "prop": "newTotalQty"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": _vm.editMixedPackageUPCQtyForm.claimedQty,
      "max": 99999,
      "placeholder": "Enter new total quantity"
    },
    model: {
      value: (_vm.editMixedPackageUPCQtyForm.newTotalQty),
      callback: function($$v) {
        _vm.$set(_vm.editMixedPackageUPCQtyForm, "newTotalQty", $$v)
      },
      expression: "editMixedPackageUPCQtyForm.newTotalQty"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_vm._v("\n          Note: New total quantity cannot be less than claimed quantity (" + _vm._s(_vm.editMixedPackageUPCQtyForm.claimedQty) + ")\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editMixedPackageUPCQtyDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editingMixedPackageUPCQty
    },
    on: {
      "click": _vm.confirmEditMixedPackageUPCQty
    }
  }, [_vm._v("\n        Confirm\n      ")])], 1)], 1), _vm._v(" "), _c('ImportResultDialog', {
    attrs: {
      "visible": _vm.importResultDialogVisible,
      "result": _vm.importResultData
    },
    on: {
      "update:visible": function($event) {
        _vm.importResultDialogVisible = $event
      },
      "continue": _vm.handleImportContinue,
      "retry-failed": _vm.handleRetryFailed,
      "close": _vm.handleImportResultClose
    }
  }), _vm._v(" "), _c('BulkConfirmResultDialog', {
    attrs: {
      "visible": _vm.bulkConfirmResultDialogVisible,
      "result": _vm.bulkConfirmResultData
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkConfirmResultDialogVisible = $event
      },
      "continue": _vm.handleBulkConfirmContinue,
      "retry-failed": _vm.handleBulkConfirmRetryFailed,
      "close": _vm.handleBulkConfirmResultClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4400a3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mixedPackage/MixedPackageList.vue
// module id = 847
// module chunks = 1